<div class="map-tool-container">

<!--  <arcgis-scene item-id="a7e08cb92cd9444bb4903bae6d262f29" id="map-component" class="map-view">-->
  <arcgis-map [itemId]="webmapId" id="map-component" class="map-view">
    <arcgis-search slot="top-left"
                   [sources]="searchSources"></arcgis-search>
    <arcgis-locate slot="top-left"></arcgis-locate>
    <arcgis-compass slot="top-left"></arcgis-compass>
    <arcgis-expand slot="top-right" group="top-right" id="layerListExpand" expand-tooltip="Layer List">
      <arcgis-layer-list></arcgis-layer-list>
    </arcgis-expand>

    <arcgis-expand slot="top-right" id="legendExpand" group="top-right" expand-tooltip="Legend">
      <arcgis-legend></arcgis-legend>
    </arcgis-expand>

    <arcgis-expand slot="top-right" id="basemapExpand" group="top-right" expand-tooltip="Basemap Gallery">
      <arcgis-basemap-gallery></arcgis-basemap-gallery>
    </arcgis-expand>

    <arcgis-expand slot="bottom-right" id="measurementExpand" group="top-right" expand-tooltip="Distance Measurement Tools">
      <arcgis-distance-measurement-2d></arcgis-distance-measurement-2d>
    </arcgis-expand>
    <arcgis-expand slot="bottom-right" id="areaMeasurementExpand" group="top-right" expand-tooltip="Area Measurement Tools">
      <arcgis-area-measurement-2d></arcgis-area-measurement-2d>
    </arcgis-expand>
    <arcgis-expand slot="bottom-right" id="elevationExpand" group="top-right" expand-tooltip="Elevation Profile">
        <arcgis-elevation-profile></arcgis-elevation-profile>
    </arcgis-expand>

    <arcgis-expand slot="bottom-left" id="sketchExpand" group="top-right" expand-tooltip="Sketch Tool">
        <arcgis-sketch></arcgis-sketch>
    </arcgis-expand>
    <arcgis-expand slot="bottom-left" id="printExpand" group="top-right" expand-tooltip="Print Tool"
                   >
        <arcgis-print print-service-url="https://gis.epa.guam.gov/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"></arcgis-print>
    </arcgis-expand>

  </arcgis-map>

  <!-- Feature table toggle bar sits between map and table -->
  <div class="feature-table-bar" (click)="toggleFeatureTable()">
    <span class="feature-table-bar-label">
      Feature Attributes Table
      <i class="fa" [class.fa-chevron-up]="featureTableOpen" [class.fa-chevron-down]="!featureTableOpen"></i>
    </span>
  </div>

  <!-- Feature table panel — shown/hidden via CSS class so the map flexes to fill the space -->
  <div class="feature-table-panel" [class.open]="featureTableOpen" #tablePanel>
    <!-- Drag handle — grab to resize panel height -->
    <div class="resize-handle" #resizeHandle title="Drag to resize">
      <span class="resize-handle-grip"></span>
    </div>
    <arcgis-feature-table reference-element="map-component" [showLayerDropdown]="true"></arcgis-feature-table>
  </div>

</div>

